import React, { useEffect } from "react";
import { useField, useFormikContext } from "formik";
import { Form, Row, Col } from "react-bootstrap";
import SummaryItem from "../components/SummaryItem/SummaryItem";
import { useSelector } from "react-redux";
import { SwitchUser } from "../../../helpers/helpers";
import _ from "lodash";

export default function SwitchRadioField(props) {
  const {
    label,
    options,
    onSelected,
    stepToExclude,
    validationSchema,
    ...rest
  } = props;
  const { summaryMode } = rest;
  const [field, meta, helper] = useField(props);
  const { setValue } = helper;
  const { values, setFieldValue } = useFormikContext();

  const user = useSelector((state) => state.auth);
  const userProfile = SwitchUser(user);
  const selectedValue = _.head(options.filter((i) => i.value === field.value));
  const valueToRender = selectedValue ? selectedValue.label : "";
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;
  function _onChange(e) {
    if (onSelected) {
      onSelected(e.target.value, values, userProfile, setFieldValue);
    }
    setValue(e.target.value);
  }

  useEffect(() => {
    _onChange({ target: { value: field.value } });
    // eslint-disable-next-line
  }, [field.value]);
  function optionToExclude(option) {
    if (stepToExclude) {
      let stepToExcludeVariable = stepToExclude();
      return !stepToExcludeVariable.includes(option.value);
    } else return true;
  }
  return (
    <Form.Group
      className={
        meta.touched && meta.error ? "radio-button is-invalid" : "radio-button"
      }
    >
      {!summaryMode ? (
        <>
          <Row>
            <Col>
              {label && (
                <Form.Label className="paragraph-small-fs9">{label}</Form.Label>
              )}
            </Col>
          </Row>
          <Row>
            {options
              .filter((option) => optionToExclude(option))
              .map((option, index) => {
                const { grid: gridProps } = option;
                return (
                  <Col
                    {...gridProps}
                    key={`option-${index}`}
                    className="form-check abc-radio"
                  >
                    <input
                      type="radio"
                      className="form-check-input"
                      name={field.name}
                      id={option.id}
                      value={option.value}
                      checked={meta.value === option.value}
                      onChange={_onChange}
                      required={isRequired}
                    />
                    <label className="form-check-label" htmlFor={option.id}>
                      {option.label}
                    </label>
                  </Col>
                );
              })}
          </Row>
          {meta.touched && meta.error && (
            <span
              className="form-error-text paragraph-small-form"
              role="alert"
              id={field.name + "-error"}
            >
              {meta.error}
            </span>
          )}
        </>
      ) : (
        <>
          <Row>
            <Col>
              {label && (
                <span className="paragraph-small-fs9">{label}</span>
              )}
            </Col>
          </Row>
          <SummaryItem value={valueToRender} error={meta.error} />
        </>
      )}
    </Form.Group>
  );
}
